import { useEffect } from 'react';

import { setDeviceHeaders } from 'API';
import { DeviceSelectors } from 'store/Device';
import { useAppSelector } from 'store/hooks';

export function useDeviceHeaders() {
  const registeredDeviceUUID = useAppSelector(
    DeviceSelectors.selectRegisteredUUID,
  );

  useEffect(() => {
    setDeviceHeaders(registeredDeviceUUID);
  }, [registeredDeviceUUID]);
}
